// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","field":"field-12zq3","name":"name-1JeKc","input":"input-1aQP8"};